import { jsx as _jsx } from "react/jsx-runtime";
import styles from './App.module.scss';
import { RouterProvider } from 'react-router-dom';
import { router } from './Router';
const App = () => (_jsx("div", { className: styles.container, children: _jsx(RouterProvider, { router: router }) }));
export default App;
